import React from "react";
import "./Weather.css";
import "./styles.css";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";
import FormattedDate from "./FormattedDate";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div className="CityOverview">
      <div className="currentDate">
  <FormattedDate date={props.data.date} />
</div>
        <div className="row">
          <div className="col"></div>
          <div className="col">
            <div className="glass-container">
              <WeatherIcon code={props.data.icon} size={80} className="weather-icon img-fluid" />
              <h1 className="">{props.data.city}</h1>
              <h2 className="capitalize">{props.data.description}</h2>
              <div className="temperature-container">
                <WeatherTemperature celsius={props.data.temperature} unit={props.unit} />
                <span className="unit-switch" onClick={props.changeUnit}> |
                  {props.unit === "celsius" ? "°F" : "°C"}
                </span>
              </div>
              <p className="temperature mb-0">
                <i>
                  Feels Like:{" "}
                  {Math.round(
                    props.unit === "celsius"
                      ? props.data.feelsLike
                      : props.data.feelsLike * (9 / 5) + 32
                  )}
                  °{props.unit === "celsius" ? "C" : "F"}
                </i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
